/**
 * @generated SignedSource<<f60c1cd1b9ea36f42576a74410031ca3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LockNote_note$data = {
  readonly canUnlockNote: boolean;
  readonly id: string;
  readonly isLocked: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"MenuItemTooltip_useGetPropsForExternalWorkspaces_note">;
  readonly " $fragmentType": "LockNote_note";
};
export type LockNote_note$key = {
  readonly " $data"?: LockNote_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"LockNote_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LockNote_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLocked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canUnlockNote",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MenuItemTooltip_useGetPropsForExternalWorkspaces_note"
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "48d62ef33bb1b677c3483d03c15d2ac2";

export default node;
